import { render, staticRenderFns } from "./PartnerMagicLogin.vue?vue&type=template&id=87b95f22&scoped=true"
import script from "./PartnerMagicLogin.vue?vue&type=script&lang=js"
export * from "./PartnerMagicLogin.vue?vue&type=script&lang=js"
import style0 from "./PartnerMagicLogin.vue?vue&type=style&index=0&id=87b95f22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b95f22",
  null
  
)

export default component.exports